import React, {useEffect, useRef, useState} from 'react'
import {IProfileDetails, profileDetailsInitValues as initialValues} from '../SettingsModel'
import { fetchData, toasterrormsg } from '../../../../../../reusable'
import { ToastContainer } from 'react-toastify'
import { useLocation } from 'react-router-dom'

const VendorBankDetail: React.FC = () => {
 const locations=useLocation();
 var vendor=new URLSearchParams(locations.search);
 var vandorId:any=vendor.get("edit")
 vandorId=atob(vandorId)

 if(vandorId=="")
 {
   vandorId=sessionStorage.getItem("vendorId")
   vandorId=atob(vandorId)
 }

  

  const [vendorData,setVendorData]=useState(Object)

    //overview states
    const [ifscCode,setifscCode]=useState("");
    const [propertyOwnerName,setpropertyOwnerName]=useState("");
    const [branchName, setbranchName] = useState('');
    const [bankName,setbankName]=useState("");
    const [businessName,setBusinessName]=useState("");
    const [accountName,setaccountName]=useState("");
    const [region,setRegion]=useState("");
    const [addressLine2,setAddressLine2]=useState("");
    const [zipCode,setzipCode]=useState("");
    const [addressLine1,setAddressLine1]=useState("");
    const [country,setCountry]=useState("");
    const [accountNumber, setaccountNumber] = useState("");

    useEffect(()=>{
        var vendor:any=sessionStorage.getItem("vendor");
        setVendorData(JSON.parse(vendor))
        
        getprofile()
        
    },[])

    // api call function start
    const getprofile=async()=>{
        
        var tmp:any=sessionStorage.getItem("vendor")
        tmp=JSON.parse(tmp)
        
        var param:any={
            vendorId:String(vandorId),
        }
        var response:any=await fetchData("vendor/public/viewProfile",param)
        
        if(response.status=="200")
        {
            
            var data=response.data[0]
            setifscCode(data['ifscCode'])
            setpropertyOwnerName(data['propertyOwnerName'])
            setbranchName(data['branchName'])
            setbankName(data['bankName'])
            setaccountName(data['accountName'])
            setaccountNumber(data['accountNumber'])
            setBusinessName(data['bussinessName'])
            setBusinessName(data['bussinessName'])
            setzipCode(data['zipcode'])
            setRegion(data['region'])
            setAddressLine1(data['addressline1'])
            setAddressLine2(data['addressline2'])
        }
        else
        {
            toasterrormsg(response.message)
            
        }
    }
  
  
  return (
    <>
    <ToastContainer />
      <div className='card mb-5 mb-xl-10'>
        <div
          className='card-header border-0'
         
        >
       
        </div>

        <div className="card-body">
        <div className='d-flex flex-wrap flex-stack'>
              <div className='d-flex flex-column flex-grow-1 pe-8'>
                <div className='d-flex flex-wrap'>
                  <div className='border border-gray-300 border-dashed rounded min-w-125px py-3 px-4 me-6 mb-3'>
                    <div className='d-flex align-items-center'>
                      <div className='fs-2 fw-bolder'>{propertyOwnerName || " "}</div>
                    </div>

                    <div className='fw-bold fs-6 text-gray-400'>Owner Name</div>
                  </div>
                  <div className='border border-gray-300 border-dashed rounded min-w-125px py-3 px-4 me-6 mb-3'>
                    <div className='d-flex align-items-center'>
                      <div className='fs-2 fw-bolder'>{businessName || " "}</div>
                    </div>

                    <div className='fw-bold fs-6 text-gray-400'>Business Name</div>
                  </div>
                  <div className='border border-gray-300 border-dashed rounded min-w-125px py-3 px-4 me-6 mb-3'>
                    <div className='d-flex align-items-center'>
                      <div className='fs-2 fw-bolder'>{country || " "}</div>
                    </div>

                    <div className='fw-bold fs-6 text-gray-400'>Country</div>
                  </div>

                  <div className='border border-gray-300 border-dashed rounded min-w-125px py-3 px-4 me-6 mb-3'>
                    <div className='d-flex align-items-center'>
                      <div className='fs-2 fw-bolder'>{region || " "}</div>
                    </div>

                    <div className='fw-bold fs-6 text-gray-400'>Region</div>
                  </div>
                  <div className='border border-gray-300 border-dashed rounded min-w-125px py-3 px-4 me-6 mb-3'>
                    <div className='d-flex align-items-center'>
                      <div className='fs-2 fw-bolder'>{addressLine1 || " "}</div>
                    </div>

                    <div className='fw-bold fs-6 text-gray-400'>Address Line 1</div>
                  </div>
                  <div className='border border-gray-300 border-dashed rounded min-w-125px py-3 px-4 me-6 mb-3'>
                    <div className='d-flex align-items-center'>
                      <div className='fs-2 fw-bolder'>{addressLine2 || " "}</div>
                    </div>

                    <div className='fw-bold fs-6 text-gray-400'>Address Line 2</div>
                  </div>
                  <div className='border border-gray-300 border-dashed rounded min-w-125px py-3 px-4 me-6 mb-3'>
                    <div className='d-flex align-items-center'>
                      <div className='fs-2 fw-bolder'>{zipCode || " "}</div>
                    </div>

                    <div className='fw-bold fs-6 text-gray-400'>Zip Code</div>
                  </div>
                </div>
              </div>

            </div>
          
        </div>
      </div>
    </>
  )
}

export {VendorBankDetail}
